import { render, staticRenderFns } from "./PrjLogs.vue?vue&type=template&id=320a91f4&scoped=true&"
import script from "./PrjLogs.vue?vue&type=script&lang=ts&"
export * from "./PrjLogs.vue?vue&type=script&lang=ts&"
import style0 from "./PrjLogs.vue?vue&type=style&index=0&id=320a91f4&lang=scss&scoped=true&"
import style1 from "./PrjLogs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a91f4",
  null
  
)

export default component.exports